import { useState } from 'react';
import { seoContent } from '@/mocks/seoData';

function buildFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': seoContent.faqs.map((faq) => ({
      '@type': 'Question',
      'name': faq.question,
      'acceptedAnswer': {
        '@type': 'Answer',
        'text': faq.answer,
      },
    })),
  };
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(buildFaqSchema()) }}
      />
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            {seoContent.faqTitle}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {seoContent.faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/60 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  <span className="text-primary-500 font-bold mr-2">Q{index + 1}.</span>
                  {faq.question}
                </span>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                  <i
                    className={`text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`faq-answer ${openIndex === index ? 'open' : ''}`}
              >
                <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}